import { get, join, map } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SubmissionError } from 'redux-form';

import Loader from '../../components/Loader';
import {
    checkDomainBlacklisted,
    saveDomainDetailsPage,
    trackEvent as trackEventAction,
    setGetDomainError, getDomainStatus
} from '../../store/signup/signupAction';
import DomainDetailsForm from './DomainDetailsForm';

const DomainDetails = ({
    saveDomainDetailsPage,
    otpVerified,
    domainDetailsData,
    trackEvent,
    setGetDomainError,
    checkDomainBlacklisted, getDomainStatus, formId = null,basicData
}) => {
    const history = useHistory();
    /**
     * Validate daa and save domain
     * @param {*} data
     */
    const validateAndSaveDomainDetails = (data) => {
        return checkDomainBlacklisted(data).then(async (res) => {
            if (get(res, 'blacklisted', false)) {
                throw new SubmissionError({
                    businessDomain: 'Please use your business domain',
                    _error: 'failed',
                });
            }
            await getDomainStatus(data.businessDomain, get(basicData, 'form_id', formId)).then(resp => {
                if (resp.status)
                    throw new SubmissionError({
                        businessDomain: 'This domain is already registered with InfinCE. Please try another domain.',
                        _error: 'failed',
                    });

            })
            setIsLoading(true);
            saveDomainDetailsPage(data);
            setIsLoading(false);
            setGetDomainError(null);
            trackEvent(process.env.REACT_APP_TRACKER_NORMAL_SIGNUP_STEP_2_ENDPOINT_ID, {
                domainName: get(data, 'businessDomain'),
                businessName: get(data, 'businessName'),
                businessTypes: join(map(get(data, 'businessType', []), 'label'), ', '),
                firstName: get(basicData, 'first_name', ''),
                lastName: get(basicData, 'last_name', ''),
                email: get(basicData, 'email', ''),
                formId: get(basicData, 'form_id', ''),
            });
            history.push('/registration/choose-plan');
        });
    };

    useEffect(() => {
        if (!otpVerified) {
            history.push('/registration/validate');
        }
    }, [otpVerified, history]);

    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className="content signup">
            {isLoading && <Loader />}
            <div className="content-block-right">
                <h1>Domain Details</h1>
                <p>Please share your business and domain details</p>
                <div className="sec-header-block"></div>

                <DomainDetailsForm
                    submit={validateAndSaveDomainDetails}
                    initialValues={domainDetailsData}
                />
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    saveDomainDetailsPage,
    setGetDomainError,
    trackEvent: trackEventAction,
    checkDomainBlacklisted, getDomainStatus
};
const mapStateToProps = (store, props) => ({
    otpVerified: get(store, 'signupReducer.otpVerified', false),
    domainDetailsData: get(store, 'signupReducer.domainDetails'),
    basicData: get(store, 'signupReducer.basicData')
});

export default connect(mapStateToProps, mapDispatchToProps)(DomainDetails);
